import Touchable from "src/components/Touchable";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { ActionIconButtonProps } from "./types";

/**
 * Simple icon button designed for inline use with text
 *
 * Not currently a generic component, but could be in the future if this shows up more in designs
 */
const ActionIconButton = ({ Icon, containerStyle, onPress, disabled }: ActionIconButtonProps) => {
	const { theme } = useStyle();
	const size = 20;
	const borderWidth = size / 20;

	return (
		<Touchable
			onPress={onPress}
			containerStyle={[
				containerStyle,
				{
					borderColor: color.Text[theme],
					borderWidth: borderWidth,
					width: size,
					height: size,
					borderRadius: size / 2,
				},
			]}
			style={{
				alignItems: "center",
				justifyContent: "center",
				flex: 1,
			}}
			disabled={disabled}
		>
			<Icon color={color.Text[theme]} size={0.55 * size} />
		</Touchable>
	);
};
export default ActionIconButton;
